import { styled } from "@mui/system";
import { Box, Button } from "@mui/material";

export const SocialAuthContainer = styled(Box)({
  width: "390px",
  height: '480px',
  padding: "24px 16px 48px 16px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",
  backgroundColor: "rgba(116, 116, 128, 0.18)",
  borderRadius: "32px",

  boxShadow: "0px -0.5px 0px 0px rgba(0, 0, 0, 0.30)",
  backdropFilter: "blur(10px)",
  border: '0px solid rgba(84, 84, 88, 0.65) '

});

export const LogoTextContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",
  marginBottom: '76px',
});

export const ButtonsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",
  width: "100%",
});

export const LogoImage = styled("img")({
  width: "56px",
  height: "56px",
});

export const AuthButton = styled(Button)({
  width: "100%",
  maxWidth: "400px",
  padding: "12px 20px",
  textTransform: "none",
  fontWeight: 500,
  fontSize: "16px",
  borderRadius: "8px",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
});
